import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { Auth } from "aws-amplify";
import * as XLSX from "xlsx";
import Button from "../layout/button";
import { getSurveysFromAPI, addSurveyFromAPI } from "../../services/surveyService";
import { addQuestionFromAPI } from "../../services/questionService";
import { updateTabStates, setSurveys, updateTabPath } from "../../store/actions";

export default function CreateFromFile() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const themeMode = useSelector((state) => state.themeMode);
  const questions = useSelector((state) => state.questions);
  const organizations = useSelector((state) => state.organizations);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  // const questions = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.questions;
  // const organizations = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.organizations;

  let [token, setToken] = useState("");
  const [surveyName, setSurveyName] = useState("");
  const [selectedOrganization, setSelectedOrganization] = useState({});
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [query, setQuery] = useState("");
  const [selectedOption, setSelectedOption] = useState("excel");
  const [isChecked, setIsChecked] = useState(false); // Checkbox durumunu kontrol etmek için
  const [excelSurveyContent, setExcelSurveyContent] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [newQuestionType, setNewQuestionType] = useState("text");
  const [showOrganizations, setShowOrganizations] = useState(false);
  const [newSurveyJsonContent, setNewSurveyJsonContent] = useState("");
  const [importInfoMenuShow, setImportInfoMenuShow] = useState(false);
    const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [infoText, setInfoText] = useState("")
  const [selectedFunction, setSelectedFunction] = useState("");
  const [selectedFunctionParam, setSelectedFunctionParam] = useState("");

  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (Object.keys(excelSurveyContent).length > 0) {
      saveSurvey();
    }
  }, [excelSurveyContent]);

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    
  }
  useEffect(() => {
    if (token.length > 0) {
      if (selectedFunction === "saveQuestion") {
        saveQuestion(selectedFunctionParam);
      } else if (selectedFunction === "getSurveys") {
        getSurveys(selectedFunctionParam);
      } else if (selectedFunction === "saveSurvey") {
        saveSurvey();
      }
      setSelectedFunction("");
      setSelectedFunctionParam("");
    }
  }, [token]);

  const processExcel = async (data) => {
    const surveyJson = { pages: [] };
    const dimensions = Array.from(new Set(data.map((row) => row.Dimension)));
    for (const dimension of dimensions) {
      const trimmedDimension = dimension.trim().toLowerCase();
      const dimensionRows = data.filter((row) => {
        const rowDimension = row.Dimension.trim().toLowerCase();
        return rowDimension === trimmedDimension;
      });
      if (dimensionRows.length === 0) return;
      const page = {
        name: dimension,
        title: dimension.toUpperCase(),
        type: dimension === "Demographics" ? "demographics" : "",
        elements: [],
      };
      const panel = {
        type: "panel",
        name: dimension,
        elements: [],
      };
      const components = dimensionRows.map((row) => row.Component);
      const uniqueComponents = Array.from(new Set(components));

      for (const component of uniqueComponents) {
        let componentRows = dimensionRows.filter(
          (row) => row.Component === component
        );
        if (componentRows.length === 0) return;
        panel.elements.push({
          type: "html",
          name: component,
          html: `<h5>${component}</h5>`,
        });
        componentRows
          // .filter((x) => x.type !== undefined)
          .forEach((row) => {
            const optionsForRow = componentRows
              .filter(
                (x) => x.question === row.question && x.type === undefined
              )
              .map((x) => x.options);

            if (optionsForRow.length > 0) {
              row["options"] = optionsForRow.filter((option) => option !== "");
            }
          });
        const addedQuestions = new Set();
        for (const row of componentRows
          .filter((x) => x.type !== "matrix")
          .slice(1)) {
          if (!addedQuestions.has(row.question)) {
            const type = componentRows[0].type;

            panel.elements.push({
              type: "panel",
              name: component,
              elements: [
                {
                  type: row["type"] || type || "radiogroup",
                  isRequired: true,
                  name: row["question"],
                  title: row["question"],
                  choices: row.options.map((option, index) => ({
                    value: index + 1,
                    text: option,
                  })),
                },
              ],
            });
          }
          addedQuestions.add(row.question);
        }
      }

      if (panel.elements.length > 0) {
        page.elements.push(panel);
      }
      if (page.elements.length > 0) {
        surveyJson.pages.push(page);
      }
    }
    return surveyJson;
  };

  async function handleFileChange(event) {
    if (surveyName === "") {
      setInfoText("Please enter survey name first")

     setSuccess(false);
      setImportInfoMenuShow(true)
      event.target.value = "";
      return;
    }
    dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
    if (event.target.files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || event.target.files[0].type === "application/vnd.ms-excel") {
      const file = event.target.files[0];
      setUploadedFileName(file.name);
      const reader = new FileReader();
      const readFile = () => {
        return new Promise((resolve, reject) => {
          reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const jsonData = XLSX.utils.sheet_to_json(
              workbook.Sheets[workbook.SheetNames[0]]
            );
            resolve(jsonData); // Resolve the Promise with jsonData
          };
          reader.onerror = (error) => {
           setSuccess(false); setSuccess(false);  setError(true);
            setInfoText("Error processing file" + error)
            reject(error); // Reject the Promise on error
          };
        });
      };

      reader.readAsArrayBuffer(file);

      try {
        const jsonData = await readFile(); // Wait for the file to be read
        const json_excel = await processExcel(jsonData); 
        let defaultSurveyJson = {
          pages: [],
          progressBarType: "pages",
          questionsOnPageMode: "standard",
          showPageTitles: false,
          showQuestionNumbers: "on",
          showProgressBar: "top",
          progressBarShowPageTitles: true,
          progressBarShowPageNumbers: true,
          firstPageIsStarted: false,
          startSurveyText: "Start Survey",
          widthMode: "static",
          width: "1500",
        };
        defaultSurveyJson.pages = json_excel.pages;
        setExcelSurveyContent(defaultSurveyJson);
        setImportInfoMenuShow(true)
       setSuccess(true); setError(false);
        setInfoText("File uploaded and processed successfully")
      } catch (error) {
       setSuccess(false);  setError(true);
        setInfoText("Error processing file" )
        // console.error("Error processing file:", error); // Handle errors gracefully
        dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
      }
    } else if (event.target.files[0].type === "application/json") {
      try {
        const file = event.target.files[0];
        setUploadedFileName(file.name);
        const reader = new FileReader();
        reader.onload = (e) => {
          const content = e.target.result;
          setExcelSurveyContent(JSON.parse(content));
          setImportInfoMenuShow(true)
         setSuccess(true); setError(false);
          setInfoText("File uploaded and processed successfully")
        };
        reader.readAsText(file);
      } catch (error) {
       setSuccess(false);  setError(true);
        setInfoText("Error processing file")
        // console.error("Error processing file");
        dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
      }
    } else {
      dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
    }
  }

  async function updateNestedElements(elements) {
    for (const element of elements) {
      if (element.elements && Array.isArray(element.elements)) {
        await updateNestedElements(element.elements);
      } else {
        let isMatched = false;
        if (element.title) {
          for (const question of questions) {
            if (question.question && typeof question.question === "string") {
              if (
                element.title.trim().toLowerCase() ===
                question.question.trim().toLowerCase()
              ) {
                {
                  const elementValues =
                    (element.options && Array.isArray(element.options)
                      ? element.options.map((choice) => choice.value)
                      : element.choices && Array.isArray(element.choices)
                        ? element.choices.map((choice) => choice.text)
                        : []) || [];
                  const choicesMatch =
                    ((!element.options || !Array.isArray(element.options)) &&
                      (!element.choices || !Array.isArray(element.choices))) ||
                    (elementValues.length > 0 &&
                      question.options &&
                      Array.isArray(question.options) &&
                      elementValues.length === question.options.length &&
                      elementValues.every((value) =>
                        question.options.includes(value)
                      ));
                  const typeMatch =
                    !question.type || element.type === question.type;

                  if (choicesMatch && typeMatch) {
                    isMatched = true;
                    element.name = question.ID;
                    break;
                  } else {
                    isMatched = false;
                    break;
                  }
                }
              } else {
                isMatched = false;
              }
            }
          }
          if (!isMatched) {
            const questionId = await saveQuestion(element);
            element.name = questionId;
          }
        }
      }
    }
    return elements;
  }

  async function updatePageElements(page) {
    if (page.elements && Array.isArray(page.elements)) {
      const updatedElements = await updateNestedElements(page.elements);
      return updatedElements;
    }
  }

  async function getSurveys(new_survey_id) {
    try {
      const result = await getSurveysFromAPI(token);

      result["surveys"].forEach((survey) => {
        survey["responded"] = result["userSurveyItems"].filter(
          (item) => item.survey_id === survey.ID && item.is_completed).length + "/"
          + result["userSurveyItems"].filter((item) => item.survey_id === survey.ID).length + " Responded";
      });
      dispatch(setSurveys(result["surveys"]));
      if (new_survey_id) {
        dispatch(updateTabStates(topMenuTabs.activeTab, "currentSurvey", result["surveys"].find(survey => survey.ID === new_survey_id)));
        dispatch(updateTabStates(topMenuTabs.activeTab, "surveyDetailSelectedTab", "Summary"));
        dispatch(updateTabPath(topMenuTabs.activeTab, 'Summary', `/surveys/${new_survey_id}/summary`));
        dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
        navigate(`/surveys/${new_survey_id}/summary`);
      }
    } catch (error) {
      if (error?.message === "Request failed with status code 401") {
        setSelectedFunction("getSurveys");
        setSelectedFunctionParam(new_survey_id);
        checkAuth();
      }
    }
  }

  async function saveSurvey() {
    const userCognitoInfo = await Auth.currentUserInfo()
    if (excelSurveyContent != "") {
      try {
        for (const page of excelSurveyContent.pages) {
          const updatedPage = await updatePageElements(page); // Elemanları güncelle
        }
        const obj = {
          survey_name: surveyName,
          organization: userCognitoInfo.attributes['custom:org_name'],
          content: excelSurveyContent,
        };

        await addSurveyFromAPI(token, obj)
          .then((result) => {
            getSurveys(result.survey_id);
          })
          .catch((error) => {
            if (error?.message === "Request failed with status code 401") {
              setSelectedFunction("saveSurvey");
              checkAuth();
            } else {
             setSuccess(false);  setError(true);
              setInfoText("An error occured while saving survey")
              setImportInfoMenuShow(true)
            }
          });
      } catch (error) {
       setSuccess(false);  setError(true);
        setInfoText("An error occured while saving survey")
        setImportInfoMenuShow(true)
      }
    } else {
      // survey['content'] = survey['content'].replace(/\n/g, "").replace(/\s{2,}/g, "");
      let _newSurveyJsonContent = { ...newSurveyJsonContent };
      if (typeof newSurveyJsonContent === "object") {
        _newSurveyJsonContent = JSON.stringify(newSurveyJsonContent);
      }
      try {
        _newSurveyJsonContent = JSON.parse(newSurveyJsonContent);
      } catch (error) {
        // console.error("Invalid JSON content");
       setSuccess(false);  setError(true);
        setInfoText("Failed to load survey: Invalid JSON format.");
        setImportInfoMenuShow(true); // Hata olsa bile menüyü göster
        return;
      }

      for (const page of _newSurveyJsonContent.pages) {
        await updatePageElements(page); // Recursive fonksiyonla elementleri güncelle
      }
      try {
        const obj = {
          survey_name: surveyName,
          organization: userCognitoInfo.attributes['custom:org_name'],
          content: _newSurveyJsonContent,
        };
        await addSurveyFromAPI(token, obj)
          .then((result) => {
          })
          .catch((error) => {
            if (error?.message === "Request failed with status code 401") {
              setSelectedFunction("saveSurvey");
              checkAuth();
            } else {
             setSuccess(false);  setError(true);
              setInfoText("An error occured while saving survey")
              setImportInfoMenuShow(true)
            }
          });
      } catch (error) {
       setSuccess(false);  setError(true);
        setInfoText("An error occured while saving survey")
        setImportInfoMenuShow(true)
      }
    }
  }

  async function saveQuestion(question) {
    try {
      const userCognitoInfo = await Auth.currentUserInfo()
      const obj = {
        options:
          question.options ||
          (question.choices
            ? question.choices.map((choice) => choice.text)
            : ""),
        question: question.title || question.question,
        type: question.type || newQuestionType,
        organization_id: organizations.find(x => x.organization_name === userCognitoInfo.attributes['custom:org_name']).ID,
      };
      const result = await addQuestionFromAPI(token, obj);
      return result.question_id;
      
    } catch (error) {
      if (error?.message === "Request failed with status code 401") {
        setSelectedFunction("saveQuestion");
        setSelectedFunctionParam(question);
        checkAuth();
      } else {
       setSuccess(false);  setError(true);
        setInfoText("An error occured while saving question,please check the data and try again")
        setImportInfoMenuShow(true)
        return false;
      }
    }
  }

function downloadTemplate(type) {
  if (type === "excel") {
    fetch("/assets/excel/maturityexcel_new.xlsx")
      .then(response => {
        if (!response.ok) throw new Error("Network error");
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "survey_template.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      });

  } else if (type === "json") {
    fetch("/assets/json/maturity_template.json")
      .then(res => res.json())
      .then(data => {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "survey_template.json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch();
  }
}

  useEffect(() => {
    const timer = setTimeout(() => {
      setImportInfoMenuShow(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [importInfoMenuShow, setImportInfoMenuShow]);
  return (
    <div
      className={`flex flex-col xs:justify-center xs:items-center  gap-2 p-0 pr-0  sm:p-0 md:p-2 sm:pl-3 md:pl-12 lg:pl-12 xl:pl-12 mt-4 w-full xxs:w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%]
      `}
    >
      <div className={`flex flex-col items-center justify-start gap-2  p-2  sm:p-4 md:p-5 lg:p-6 min-h-[22vh]  xxs:w-[85%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%] rounded-md"
        ${themeMode === "dark"
          ? "bg-[#a5bdff0d]"
          : "bg-[#1530720d]"
        }
          `}>
        <label className="w-full xxs:w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%] flex justify-between gap-2 flex-col sm:flex-col md:flex-col lg:flex-col xxs:flex-row xl:flex-col xxs:flex-row" id="cffSurveyTitle">
          <div className="flex gap-2">
            <span
              className={`font-bold  whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0  text-xs sm:text-sm ${themeMode === "dark"
                ? "text-white text-opacity-60"
                : "text-black text-opacity-60"
                }`}
            >
              Survey Title
            </span>
          </div>
          <div className="inline-flex  flex-col items-start min-w-0 w-[calc(100vh-50%)]  ml-0  sm:ml-0 md:ml-0 lg:ml-7 xl:ml-7">
            <div className="font-normal text-[1.25rem] w-full xxs:w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%] min-w-0 min-h-0 flex items-center flex-nowrap">
              <input
                type="text"
                value={surveyName}
                onChange={(e) => setSurveyName(e.target.value)}
                placeholder="Enter survey title"
                className={`w-full xxs:w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%] m-0 p-0 min-w-0  border-none rounded-[2px] font-inherit text-sm bg-transparent outline-none ${themeMode === "dark"
                  ? "text-white text-opacity-60"
                  : "text-[#000] text-opacity-60"
                  }`}
              />
            </div>
          </div>
        </label>
        <label className="flex w-full xxs:w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%]  flex-col space-y-8">

          <div className="flex justify-between  flex-wrap w-full  " id="cffTemplate">
            <div className="flex w-full flex-col xs:flex-row justify-center xs:justify-start gap-2 p-4 xs:mr-17 xs:p-0">

              <a
                onClick={(e) => {
                  e.preventDefault();
                  downloadTemplate("excel")
                }}
                className={`
               flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${themeMode === "dark" ? "bg-gray-500 hover:bg-gray-400 text-[#FFFFFF] text-opacity-60" : "bg-[#eaeaea] text-black text-opacity-60 hover:bg-gray-200"}   text-[12px] leading-[15px] mb-0 mt-2 font-normal cursor-pointer group inline-flex items-center  py-2 pl-2 pr-2 text-sm font-medium min-w-[4.5rem] max-w-[4.9rem]"`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-5 mr-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                  />
                </svg>
                Excel Template
              </a>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  downloadTemplate("json")
                }}
                className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]   ${themeMode === "dark" ? "bg-gray-500 hover:bg-gray-400 text-[#FFFFFF] text-opacity-60" : "bg-[#eaeaea] text-black text-opacity-60  hover:bg-gray-200"} text-[12px] leading-[15px] mb-0 mt-2 font-normal cursor-pointer group inline-flex items-center  py-2 pl-2 pr-2 text-sm font-medium min-w-[4.5rem] max-w-[4.9rem]"`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-5 mr-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                  />
                </svg>
                Json Template
              </a>
            </div>
          </div>
          <div className=" flex flex-col w-fullmin-h-0 bg-transparent opacity-100 origin-center" id="cffUploadFile">
              <div className=" antialiased box-border text-[#333] font-sans leading-none relative text-left">
                <div
                  className={` w-full h-full border border-solid border-1px   rounded max-h-full max-w-full outline-none relative p-2 ${themeMode === "dark"
                    ? "bg-gray-800 rounded-lg shadow-md border-white-09"
                    : " bg[#f4f4f4] border-black-09"
                    }`}
                >
                  <label
                    htmlFor="dropzone-file"
                    className={`flex flex-col items-center justify-center w-auto h-full border border-1px  border-dashed  rounded-lg relative overflow-hidden flex flex-col items-center space-y-4  ${themeMode === "dark"
                      ? "bg-gray-900 border border-gray-700 rounded-lg  hover:bg-[rgba(222,_222,_240,_0.1)] border-white-09 "
                      : " hover:bg-[#eaeaea] border-black-09"
                      } rounded-[0.25rem] px-4 pb-12 pt-5  sm:px-6 sm:pt-6 sm:w-full md:w-full cursor-pointer  `}
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p
                        className={`mb-2 text-sm ${themeMode === "dark"
                          ? "text-gray-400"
                          : "text-gray-400"
                          } `}
                      >
                        <span className="font-semibold">Click to upload</span>
                        {/* or
                        drag and drop */}
                      </p>
                      <p
                        className={`text-xs  ${themeMode === "dark"
                          ? "text-gray-400"
                          : "text-gray-400"
                          } `}
                      >
                        Excel or Json files (.xls, .xlsx, .json)
                      </p>
                    </div>
                    <input
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                      onChange={(e) => handleFileChange(e)}
                      accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.json"
                    />
                  </label>
                </div>
              </div>
          </div>
        </label>
        {/* <div className="flex justify-end w-full xxs:w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%] gap-2 xxs:p-3 sm:p-4 md:p-5 lg:p-6 ">
          <div className="flex flex-col xxs:flex-row w-full xxs:w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%] items-center justify-end">
            <button
              className="flex items-center text-[#4d7ff5] text-[0.875rem] py-1 px-2 border border-[#4d7ff5] bg-transparent hover:bg-[#ffffff0a] rounded-md"
              onClick={() => saveSurvey()}
            >
              Save
            </button>
          </div>
        </div> */}
      </div>
      <Dialog
        open={importInfoMenuShow}
        onClose={setImportInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.8rem]">
          <div className=" absolute flex min-h-full max-w-full xxs:w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%] min-w-[15%] items-end justify-start p-2 xxs:p-3 sm:p-4 md:p-5 lg:p-6 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                ? "bg-[#2a2939] border-white-09"
                : "bg-[#FFFFFF] border-black-09 "
                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full xxs:w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] 2xl:w-[70%] sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-col xxs:flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                      }`}
                  >
                    <div className="flex flex-col xxs:flex-row justify-start">
                          {success && (
                      <div className="flex flex-row justify-start">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            fill="#008000"
                            stroke="#fff"
                          />
                        </svg>
                        <span>Survey updated</span>
                      </div>
                    )}
                    {error && (
                      <div className="flex flex-row justify-start">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>
                        <span>Survey couldn't update</span>
                      </div>
                    )}
                      <span>{infoText}</span>
                    </div>
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <Button text="Ok" onClick={() => setImportInfoMenuShow(false)} disabled={false} themeMode={themeMode} type="button" />

              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>

  );
}
